import React, { useEffect } from 'react';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';
import PermissionGuard from 'components/shared-components/PermissionGuard';

const AppRoute = ({ component: Component, routeKey, blankLayout, resource, action, ...props }) => {

	const dispatch = useDispatch()

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		dispatch(onBlankLayout(isBlank))

	}, [blankLayout])
	
	// If route has permission requirements, wrap with PermissionGuard
	if (resource) {
		return (
			<PermissionGuard resource={resource} action={action || 'read'}>
				<Component {...props} />
			</PermissionGuard>
		);
	}
	
	return (
		<Component {...props} />
	)
}

export default AppRoute